import {InjectionToken} from '@angular/core';
import {TextileDataLastModified} from '@domain/textile-data/textile-data-last-modified';
import {Observable} from 'rxjs';

export const TEXTILE_DATA = new InjectionToken<TextileData>('TextileData');

export interface TextileData {
  getLastModified(): Observable<TextileDataLastModified>;
}
